import React from "react"
import { graphql } from "gatsby"

import { sanitizedCategories } from "@antoine-lb/business-logic"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Collapse from "../components/collapse"
import Product from "../components/product"

import styled from "styled-components"

const ProductsContainer = styled.div`
  padding: 15px 0;
  padding-right: 10px;
`

const MenuHeader = styled.h1`
  font-size: 55px;
  text-align: center;
`

const IndexPage = ({ data }) => {
    const pageSlug = data.strapiProductCategory.slug
    const sanitizedCat = sanitizedCategories(
        data.allStrapiProductCategory.edges.map(obj => obj.node)
      );
    const pageCategory = sanitizedCat.find(cat => cat.slug === pageSlug)
    return (
        <Layout>
        <SEO title={pageCategory.title} />
        <MenuHeader>{pageCategory.title}</MenuHeader>
        <div>
            {pageCategory.child_categories.map(child_categories => {
                return (
                  <Collapse
                    unicTitle={child_categories.title}
                    defaultStatus={child_categories.default_open}
                    key={child_categories.slug}
                  >
                    <ProductsContainer>
                      {child_categories.products.map(product => {
                        if (product.visible) {
                          return (
                            <Product
                              key={product.product_id}
                              product={product}
                            />
                          )
                        }
                      })}
                    </ProductsContainer>
                  </Collapse>
                )
              })}
              <ProductsContainer>
                {pageCategory.products.map(product => {
                    if (product.visible) {
                      return <Product key={product.product_id} product={product} />
                    }
                })}
              </ProductsContainer>
            </div>
            
        </Layout>
    )
}

// There is two queries because child categories cannot be fetched from strapiProductCategory
export const query = graphql`
  query ProductCategoryTemplateQuery($slug: String!) {
    strapiProductCategory(slug: { eq: $slug }) {
        slug
        title
    }
    allStrapiProductCategory {
      edges {
        node {
          title
          slug
          priority
          product_priorities
          default_open
          parent_category {
            title
            slug
            priority
            product_priorities
          }
          child_categories {
            title
            slug
            priority
            product_priorities
          }
          products {
            name
            price_in_cent
            description
            product_id
            visible
            thumbnail {
              childImageSharp {
                fluid(traceSVG: { background: "#73261988", color: "#732619" }) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
